import { Container } from 'pixi.js';

type LayerData = {
  layerName: string;
  order: number;
  layer: Container;
};

export class LayerManager {
  private readonly layerRoot: Container;
  private readonly registeredLayerMap: Map<string, LayerData>;

  public constructor(layerRoot: Container) {
    if (!layerRoot) {
      throw new Error('LayerRoot is empty.');
    }
    this.layerRoot = layerRoot;
    this.registeredLayerMap = new Map<string, LayerData>();
  }

  /**
   * Register layer
   * Greater order layers are closer
   * @param layerName Layer name
   * @param order Layer order
   */
  public registerLayer(layerName: string, order: number): Container {
    // not layer object
    if (this.layerRoot.children.length !== this.registeredLayerMap.size) {
      throw new Error('Stage has other children.');
    }

    // duplicated layer
    if (this.registeredLayerMap.has(layerName)) {
      throw new Error(`${layerName} has already registered.`);
    }

    const layer = new Container();
    layer.name = layerName;
    const registeredOrders = Array.from(this.registeredLayerMap.values()).map(e => e.order);
    const index = registeredOrders.filter(e => e <= order).length;
    this.layerRoot.addChildAt(layer, index);
    this.registeredLayerMap.set(layerName, { layerName, order, layer });
    return layer;
  }

  /**
   * Get layer
   * @param layerName Layer name
   */
  public getLayer(layerName: string): Container {
    // layer is not registered
    const layerData = this.registeredLayerMap.get(layerName);
    if (!layerData) {
      throw new Error(`${layerName} is not registered.`);
    }
    return layerData.layer;
  }
}
